import { render, staticRenderFns } from "./EnquiryCell.vue?vue&type=template&id=0f1acfd3&"
import script from "./EnquiryCell.vue?vue&type=script&lang=js&"
export * from "./EnquiryCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports